/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable camelcase */
/* eslint-disable no-warning-comments */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useState, useEffect, useMemo, useCallback
} from 'react';
import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import { MLLocalDateUtil, convertToSentenceCase } from 'ml-portals-util-js';
import { MLDriverVehicleUtil, MLNotificationBlockUtil, MLAvailableInsuredCandidatesUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { useModal } from '@jutro/components';
import AddDriverPopup from './AddDriverPopup';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { LoadSaveService } from 'gw-capability-quoteandbind';
import { FormModalPopover, platformMessages as commonMessages } from 'ml-components-platform-react';
import { MLMultiLobsDataHolderService } from 'ml-services-common-react';
import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import {
    MLInsuredCandidatesComponent,
    MLNameDetailsComponent,
    MLPartialVehicleDetailsComponent
} from 'ml-components-common-react';
import { EntityUtil } from '@xengage/gw-portals-util-js';
import classNames from 'classnames';
import _ from 'lodash';
import appConfig from 'app-config';
import metadata from './PrefillPage.metadata.json5';
import messages from './PrefillPage.messages';
import styles from './PrefillPage.module.scss';
import addDriverMessages from './AddDriverPopup.messages';

import addDriverMetadata from './AddDriverPopup.metadata.json5';
import addDriverModalBodyStyles from './AddDriverPopup.module.scss';
import removeDriverMessages from './RemoveDriverPopup.messages';

import removeDriverMetadata from './RemoveDriverPopup.metadata.json5';
import removeDriverModalBodyStyles from './RemoveDriverPopup.module.scss';
import editDriverMessages from './EditDriverPopup.messages';

import { ScrollToError } from '@jutro/legacy/wizard-next';
import { MLVehicleInfoLookupService } from 'ml-services-common-react';

const ACTION_ADD_DRIVER = 'add';
const ACTION_REMOVE_DRIVER = 'remove';
const ACTION_ADD_VEHICLE = 'add_vehicle';

function PrefillPage(props) {
    const modalApi = useModal();
    const {
        wizardData: submissionVM, updateWizardData, goNext, currentStep, updateWizardSnapshot, isSkipping
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { refreshData } = useDataRefresh();

    const paModelPath = 'lobData.personalAuto.coverables.value';
    const paModel = _.get(submissionVM, paModelPath);
    const vehiclesPath = 'lobData.personalAuto.coverables.vehicles.value';
    const vehiclesVMPath = 'lobData.personalAuto.coverables.vehicles';
    const vehicleList = _.get(submissionVM, vehiclesPath, []);
    const driversVMPath = 'lobData.personalAuto.coverables.drivers';
    const driversPath = 'lobData.personalAuto.coverables.drivers.value';
    const driverList = _.get(submissionVM, driversPath, []);

    const [vehicleToBeRemovedFlags, setVehicleToBeRemovedFlags] = useState(vehicleList.map(() => false));
    const [recentlyDeletedEntity, updateRecentlyDeletedEntity] = useState(null);
    const [recentlyAddedDriver, updateRecentlyAddedDriver] = useState(null);
    const [recentlyAddedVehicle, updateRecentlyAddedVehicle] = useState(null);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const [vinErrorCheck, updateVinErrorCheck] = useState(undefined);
    const [driverAlertShown, setDriverAlertShown] = useState(false);
    const [vehicleAlertShown, setVehicleAlertShown] = useState(false);
    const QUOTED_SUBMISSIONS_KEY = 'quotedSubmissionNumbers';

    const isHVQAddtlInfoPage = currentStep.mlStepName === 'paHVQConsumerAdditionalDrivers';
    const SELF_TAG = 'self';
    const SPOUSE_TAG = 'spouse';

    const policyStateCode = submissionVM.baseData.policyAddress.state.value.code;
    const isStateND = (state) => state === 'ND';
    const isStateMD = (state) => state === 'MD';

    const isQnB = appConfig.portalCode === 'QB';
    const directRemoveStatuses = ['unknown', 'not_household', 'notresiding'];

    const VEHICLES_LIMIT = 5;
    const DRIVERS_LIMIT = 5;

    const { nextStepVisited } = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        validateDriverRemoval,
        driverNotExcludedOrHousehold,
        getRatedDriverType,
        getHouseholdDriverType,
        getExcludedDriverType,
        getInsureDriver,
        isDriverRemovalAddHouseholdMember,
        isDriverRemovalAddRatedDriver,
        isDriverRemovalExclusion,
        getFullName,
        populateDriverPerson,
        validateDriverAddition,
        readyDriverForSave,
        guaranteeUniqueSelf,
        validateVehicleAddition,
        readyVehicleForSave,
        checkUniqueSelf,
        checkUniqueSpouse,
        isTrailer,
        getFilteredGender,
        createOnlyTrailerError,
        getModernProductRemoveDriverOptions,
        getRemoveDriverExcludedOptions,
        getHouseholdNonDriverType,
        qnBDobFieldVisibility,
        getRemoveDriverOptions
        // getMaxDateOfBirth,
        // getMinDateOfBirth
    } = MLDriverVehicleUtil(viewModelService);

    const {
        filterAvailableAutoInsuredCandidates,
        addRemovedDriverToAvailableCandidates
    } = MLAvailableInsuredCandidatesUtil();

    const vehicleCategoryTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('VehicleCategory_ML');

    const isTrailerNP = (vehicle) => {
        return vehicle.category_ML === vehicleCategoryTypelist.getCode('trailer_np').code;
    }

    const isCamperNP = (vehicle) => {
        return vehicle.category_ML === vehicleCategoryTypelist.getCode('camper_np').code;
    };
    
    const isModernProduct = _.get(submissionVM, "isModernProduct_Ext.value", false);


    const isQuoted = (quoteNumber) => {
        if (!quoteNumber) return false;
        const list = JSON.parse(localStorage.getItem(QUOTED_SUBMISSIONS_KEY) || '[]');
        return list.includes(quoteNumber);
    };

    const refreshNamedOrPrefillStatus_Ext = useCallback(() => {
        driverList.forEach((driver) => {
            driver.isPolicyHolderOrPrefilledFlag_Ext = driver.isPolicyHolder || driver.fromPrefill_ML;
        });
        refreshData();
    }, [driverList, refreshData]);

    useEffect(() => {
        if (!isSkipping) {
            PATrackEvent('Quote Step Reached', false, submissionVM, null, { step: 'Prefill Results' }, true);
        }
    }, [])

    useEffect(() => {
        refreshNamedOrPrefillStatus_Ext();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const orderedRatedDriverList = useMemo(() => {
        const driversVM = _.get(submissionVM, driversVMPath, []);
        const unsortedRatedDrivers = driverList.filter((driver) => {
            return driverNotExcludedOrHousehold(driver);
        }).map((driver) => {
            return driversVM.findFirstElement(driver);
        });

        return _.sortBy(unsortedRatedDrivers, 'publicID.value');
    }, [driverList, driverNotExcludedOrHousehold, submissionVM]);

    const {
        addSuccessAlert,
        addErrorAlert,
        addWarningAlert,
        clearSuccessAlerts,
        clearBlockAlerts,
        clearWarningAlerts,
        clearSpecificWarningAlert
    } = MLNotificationBlockUtil();

    const driverLen = useMemo(
        () => orderedRatedDriverList?.length ?? 0,
        [orderedRatedDriverList?.length]
    );

    const vehicleLen = useMemo(
        () => vehicleList?.length ?? 0,
        [vehicleList?.length]
    );

    const canAddDriver = useMemo(
        () => isQnB && driverLen < DRIVERS_LIMIT,
        [isQnB, driverLen]
    );

    const canAddVehicle = useMemo(
        () => isQnB && vehicleLen < VEHICLES_LIMIT,
        [isQnB, vehicleLen]
    );

    useEffect(()=>{
        if(!isQnB) return
         if(driverLen > DRIVERS_LIMIT && !driverAlertShown){
            addWarningAlert(translator(messages.exceedDriverLimit), 'exceedDriverLimit');
            setDriverAlertShown(true)
        } 
        if(driverLen <= DRIVERS_LIMIT && driverAlertShown) {
            clearSpecificWarningAlert('exceedDriverLimit')
            setDriverAlertShown(false)
        }
        if(vehicleLen > VEHICLES_LIMIT && !vehicleAlertShown){
            addWarningAlert(translator(messages.exceedVehicleLimit), 'exceedVehicleLimit');
            setVehicleAlertShown(true)
        } 
        if(vehicleLen <= VEHICLES_LIMIT && vehicleAlertShown) {
            clearSpecificWarningAlert('exceedVehicleLimit')
            setVehicleAlertShown(false)
        }
    }, [driverLen, vehicleLen, driverAlertShown, vehicleAlertShown])

    const today = (() => {
        const date = new Date();
        return {
            year: date.getFullYear(),
            month: date.getMonth(),
            day: date.getDate()
        };
    })();

    // const maxDateOfBirth = getMaxDateOfBirth(today);
    // const minDateOfBirth = getMinDateOfBirth(today);

    const initDrivers = () => {
        //
        // Create Driver if needed
        //
        const primaryNamedInsured = submissionVM.baseData.primaryNamedInsured_ML.value;

        const createDriverVM = () => {
            const driverObj = {
                accidents: '0',
                violations: '0',
                lastName: primaryNamedInsured.firstName,
                firstName: primaryNamedInsured.lastName,
                dateOfBirth: primaryNamedInsured.dateOfBirth,
                isPolicyHolder: true,
                isPolicyHolderOrPrefilledFlag_Ext: true,
                licenseState: submissionVM.baseData.policyAddress.state.value.code,
                relationshipToInsured_ML: SELF_TAG,
                person: primaryNamedInsured
            };
            const { _dtoName, _xCenter } = submissionVM.lobData.personalAuto.coverables.drivers;
            const driverVM = viewModelService.create(driverObj, _xCenter, _dtoName);
            submissionVM.lobData.personalAuto.coverables.drivers.pushElement(driverVM);
            return driverVM;
        };

        // this will set all driver to self if relationship to insurer is null
        driverList.forEach((driver) => {
            readyDriverForSave(driver, today);
        });

        if (_.isEmpty(driverList)) {
            const newDriverVM = createDriverVM();
            readyDriverForSave(newDriverVM.value, today);
        } else {
            guaranteeUniqueSelf(driverList, primaryNamedInsured);
        }
    };


    /*     const initVehicles = () => {
        // TODO ML: filter vehicles by vehicle.namedNonOwner_ML !== true
        // It causes a mismatch in the reference between paModel and $scope.page.driverList
        vehicleList.forEach((vehicle) => vehicle.editMode_ML = false);
    }; */

    const {
        onValidate,
        disregardFieldValidation
    } = useValidation('PrefillPage');

    const isModelValid = () => {
        return submissionVM.aspects
            ? submissionVM.aspects.valid && submissionVM.aspects.subtreeValid : false;
    };

    /**
     * Main Page
     */

    const buildDriverNodeList = () => {
        const driversVM = _.get(submissionVM, driversVMPath, []);
        const allDrivers = _.get(submissionVM, driversPath, []);

        const unsortedRatedDrivers = allDrivers.filter((driver) => {
            return driverNotExcludedOrHousehold(driver);
        }).map((driver) => {
            return driversVM.findFirstElement(driver);
        });

        return _.sortBy(unsortedRatedDrivers, 'publicID.value');
    };

    const getDriverAge = (driverDateOfBirth) => {
        if (driverDateOfBirth !== null) {
            const dob = MLLocalDateUtil.localDate2Date(driverDateOfBirth);
            return MLLocalDateUtil.differenceInYears(new Date(), dob);
        }
        return '';
    };

    const bodyTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('BodyType');

    const getTypeKeyDescription = (typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    };

    const getBodyTypeValue = (bodyType) => {
        const { name } = bodyTypelist.getCode(bodyType);
        return getTypeKeyDescription(name);
    };

    const addAlertMessage = (objName, message, undoFunction, typeAlert, nameAlert, help, clearSuccesses = true) => {
        if (clearSuccesses) {
            clearSuccessAlerts();
        }
        let alertMessage = objName ? <React.Fragment><strong> {objName} </strong> {message}</React.Fragment> : message;
        if (undoFunction) {
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            alertMessage = <React.Fragment>{alertMessage} <a role="button" tabIndex={0} onClick={undoFunction} onKeyDown={undoFunction}>Undo</a></React.Fragment>;
        }
        let alertFunc;
        if (typeAlert === 'success') {
            alertFunc = addSuccessAlert;
        } else if (typeAlert === 'error') {
            alertFunc = addErrorAlert;
        } else if (typeAlert === 'warning') {
            alertFunc = addWarningAlert;
        } else {
            alertFunc = addSuccessAlert;
        }
        const alertHelpTitle = help && help.title;
        const alertHelpMessage = help && help.message;

        alertFunc(alertMessage, nameAlert, undoFunction, alertHelpTitle, alertHelpMessage);
    };

    const countHasError_Ext = (list, isVehicles) => {
        let count = 0;
        list.forEach((i) => {
            if ((i.hasError && !isVehicles) || (i.hasError && isVehicles && !vehicleToBeRemovedFlags[i])) {
                count++;
            }
        });
        return count;
    };

    const updateInvalidPrefillBanner_Ext = () => {
        let errorCount = 0;
        errorCount += countHasError_Ext(vehicleList, true);
        errorCount += countHasError_Ext(driverList, false);
        clearBlockAlerts('invalidPrefillItem');
        if (errorCount > 0) {
            const errorMessage = translator(messages.prefillIncomplete_Ext);
            addAlertMessage(undefined, errorMessage, undefined, 'error', 'invalidPrefillItem', undefined, false);
        }
    };

    const nextStepText_Ext = () => {
        return isHVQAddtlInfoPage ? (
            <FormattedMessage
                {...messages.hvqNextDescription}
                values={{
                    yourDriverDetails: (
                        <strong>{translator(messages.hvqYourDriverDetails)}</strong>
                    )
                }}
            />
        ) : (
            <FormattedMessage
                {...messages.weWillWorkOnYourDriversNext}
                values={{
                    drivers: (
                        <strong>{translator(messages.drivers)}</strong>
                    )
                }}
            />
        );
    };

    const generateDriverOverrides = () => {
        const source = isHVQAddtlInfoPage ? _.filter(_.get(submissionVM, `${driversVMPath}.children`), (driver) => !driver.bridgedFromHVQ_ML.value) : orderedRatedDriverList;
        const overrides = source.map((driverDTO, index) => {
            _.set(driverDTO, 'editMode_ML.value', true);
            _.set(driverDTO, 'partialDriverAdditionFlag_ML.value', true);

            const driver = driverList[index];
            const driverInvalid = !driverDTO.aspects.valid || !driverDTO.aspects.subtreeValid ||
            (driverDTO.value.fromPrefill_ML === true 
                && driverDTO.value.isDobAvailable_Ext === false 
                && !driverDTO.value.dateOfBirth
            );
            const previousHasErrorVal = driver.hasError;
            driver.hasError = driverInvalid;
            if (previousHasErrorVal !== driver.hasError) {
                updateInvalidPrefillBanner_Ext();
            }

            return {
                [`driverContainer${index}`]: {
                    visible: driverNotExcludedOrHousehold(driverDTO.value) === true
                },
                [`driverErrorIcon${index}`]: {
                    visible: driverInvalid
                },
                [`driverName${index}`]: {
                    value: isQnB ? `${_.get(driverDTO, 'person.firstName.value')} ${_.get(driverDTO, 'person.lastName.value')}` : _.get(driverDTO, 'person.displayFullName_Ext.value') || _.get(driverDTO, 'person.displayName.value'),
                    className: classNames('tile__content-main', driverInvalid ? 'error-help-text' : '')
                },
                [`driverAge${index}`]: {
                    value: `${translator(messages.age)} ${getDriverAge(driverDTO.dateOfBirth.value)}`
                },
                [`removeDriverButton${index}`]: {
                    value: `${translator(messages.age)} ${getDriverAge(driverDTO.dateOfBirth.value)}`,
                    visible: isQnB ? !(checkIsDriverPNI(driverDTO)) : true,
                    className: isQnB ? 'vertical-spacing-10 footer-button-qb removeButton' : 'vertical-spacing-10 footer-button'
                },
                [`editDriverButton${index}`]: {
                    className: isQnB ? 'footer-button-qb secondaryButton' : 'footer-button'
                },
                [`driverFooter${index}`]: {
                    className: isQnB ? 'tile__footer tile-footer-override tile-footer-margin-qb' : 'tile__footer tile-footer-override'
                }
            };
        });

        return Object.assign({}, ...overrides);
    };
    

    const generateVehicleOverrides = () => {
        const vehiclesVM = _.get(submissionVM, vehiclesVMPath, []);
        const unsortedVehicles = vehicleList.map((vehicle) => {
            return vehiclesVM.findFirstElement(vehicle);
        });
        const overrides = vehicleList.map((vehicleVal, index) => {
            const vehicleVM = unsortedVehicles[index];
            if(isQnB && !isModernProduct) {
            _.set(vehicleVM, 'editMode_ML.value', true);
            }
            _.set(vehicleVM, 'partialVehicleAdditionFlag_Ext.value', true); 

            const isVehicleTypeMissing = !vehicleVM.value?.type_ML;
            
            const vehicleInvalid = !vehicleVM.aspects.valid || !vehicleVM.aspects.subtreeValid || isVehicleTypeMissing;
            const previousHasErrorVal = vehicleVal.hasError;
            vehicleVal.hasError = vehicleInvalid;
            if (previousHasErrorVal !== vehicleVal.hasError) {
                updateInvalidPrefillBanner_Ext();
            }

            let modelBodyTypeTrim = vehicleVal.model;
            if (!_.isEmpty(vehicleVal.bodyType_ML)) {
                modelBodyTypeTrim += ` ${getBodyTypeValue(vehicleVal.bodyType_ML)}`;
            }
            if (!_.isEmpty(vehicleVal.trim_ML)) {
                modelBodyTypeTrim += ` ${vehicleVal.trim_ML}`;
            }

            return {
                [`vehicleContainer${index}`]: {
                    className: vehicleToBeRemovedFlags[index] ? 'tile confirm-remove' : 'tile'
                },
                [`vehicleIcon${index}`]: {
                    visible: !vehicleToBeRemovedFlags[index]
                },
                [`vehicleErrorIcon${index}`]: {
                    visible: vehicleInvalid && !vehicleToBeRemovedFlags[index]
                },
                [`vehicleYearMake${index}`]: {
                    value: `${vehicleVal.year} ${vehicleVal.make}`,
                    visible: !vehicleToBeRemovedFlags[index],
                    className: classNames('tile__content-main', vehicleInvalid ? 'error-help-text' : '')
                },
                [`removeVehicleYearMakeDescription${index}`]: {
                    value: `${translator(messages.remove)} ${vehicleVal.year} ${vehicleVal.make}?`,
                    visible: !!vehicleToBeRemovedFlags[index]
                },
                [`vehicleModelBodyTypeTrim${index}`]: {
                    value: modelBodyTypeTrim,
                    visible: !vehicleToBeRemovedFlags[index]
                },
                [`vehicleVin${index}`]: {
                    content: <FormattedMessage
                        {...messages.vin}
                        values={{
                            vin: (
                                <strong>VIN&nbsp;</strong>
                            ),
                            value: (
                                `${vehicleVal.vin}`
                            )
                        }}
                    />,
                    visible: !_.isEmpty(vehicleVal.vin) && !vehicleToBeRemovedFlags[index]
                },
                [`vehicleFooter${index}`]: {
                    className: isQnB ? 'tile__footer tile-footer-override tile-footer-margin-qb' : 'tile__footer tile-footer-override'
                },
                [`removeVehicleButton${index}`]: {
                    visible: !vehicleToBeRemovedFlags[index],
                    className: isQnB ? 'vertical-spacing-10 footer-button-qb removeButton' : 'vertical-spacing-10 footer-button'
                },
                [`editVehicleButton${index}`]: {
                    visible: !vehicleToBeRemovedFlags[index],
                    className: isQnB ? 'footer-button-qb secondaryButton' : 'footer-button'
                },
                [`yesRemoveVehicleButton${index}`]: {
                    visible: !!vehicleToBeRemovedFlags[index],
                    className: isQnB ? 'vertical-spacing-10 footer-button-qb accentButton' : 'vertical-spacing-10 footer-button',
                    content: isQnB ? convertToSentenceCase(translator(messages.yesRemove)) : translator(messages.yesRemove)
                },
                [`dontRemoveVehicleButton${index}`]: {
                    visible: !!vehicleToBeRemovedFlags[index],
                    className: isQnB ? 'footer-button-qb secondaryButton' : 'footer-button',
                    content: isQnB ? convertToSentenceCase(translator(messages.dontRemove)) : translator(messages.dontRemove)
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const getSelectedDriverIndex = useCallback((driverToRemove) => {
        const selectedPublicID = driverToRemove?.publicID
        return driverList.findIndex((driver) => driver?.publicID === selectedPublicID);
    }, [driverList]);

    const checkIsDriverPNI = (driverVM) => {
        if (_.get(submissionVM, 'baseData.primaryNamedInsured_ML.publicID.value') === _.get(driverVM, 'person.publicID.value')) {
            return true;
        }
        return false;
    };

    const overrideProps = {
        nextDescription: nextStepText_Ext(),
        driverGroupInfoId: {
            visible: !isHVQAddtlInfoPage,
            className: isQnB ? "vertical-spacing-40 qbPadding" : "vertical-spacing-40"
        },
        paPrefillPageVehicleGroupContainer: {
            visible: !isHVQAddtlInfoPage
        },
        vehicleGroupInfoId: {
            className: isQnB ? "vertical-spacing-40 qbPadding" : "vertical-spacing-40"
        },
        driverGroupContainer: {
            data: isHVQAddtlInfoPage ? _.filter(_.get(submissionVM, `${driversVMPath}.children`), (driver) => !driver.bridgedFromHVQ_ML.value) : orderedRatedDriverList
        },
        addDriverContainer: {
            visible: !isHVQAddtlInfoPage && (canAddDriver || !isQnB) 
        },
        addVehicleContainer:{
            visible: canAddVehicle || !isQnB
        },
        vehicleGroupContainer: {
            data: _.filter(_.get(submissionVM, `${vehiclesVMPath}.children`), (vehicle) => !vehicle.namedNonOwner_ML.value)
        },
        driverGroupInfoLine1Id: {
            className: isQnB ? "subsection-header vertical-spacing-10 subHeaderLineOneQnB" : "subsection-header vertical-spacing-10"
        },
        vehicleGroupInfoLine1Id: {
            className: isQnB ? "subsection-header vertical-spacing-10 subHeaderLineOneQnB" : "subsection-header vertical-spacing-10"
        },
        addDriverButton: {
            className: isQnB ? "accentButton accentButton-override" : "",
            content: isQnB ? convertToSentenceCase(translator(messages.addDriver)) : translator(messages.addDriver)
        },
        addVehicleButton: {
            className: isQnB ? "accentButton accentButton-override" : "",
            content: isQnB ? convertToSentenceCase(translator(messages.addVehicle)) : translator(messages.addVehicle)
        },
        vehicleGroupInfoLine2Id: {
            content: isQnB ? translator(messages.vehicleGroupInfoLine2QnB) : translator(messages.vehicleGroupInfoLine2),
            className: isQnB ? "light body-copy subHeaderLineTwoQnB" : "light body-copy"
        },
        driverGroupInfoLine2Id: {
            content: isQnB ? translator(messages.driverGroupInfoLine2QB) : translator(messages.driverGroupInfoLine2),
            className: isQnB ? "light body-copy subHeaderLineTwoQnB" : "light body-copy"
        },
        ...generateDriverOverrides(),
        ...generateVehicleOverrides()
    };

    const readValue = (id, path) => {
        return readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps);
    };

    /**
     * Common
     */
    const resetPlaceholderObjs = () => {
        clearSuccessAlerts();
        updateRecentlyDeletedEntity(null);
        // $scope.addDriverModalError = null;
        // $scope.modelDescriptions = [];
        // $scope.modelCodes = [];
        // $scope.trims = [];
        // $scope.vehicleDetailsReadOnly = false;
    };

    /**
     * Driver Actions
     */

    const setRemovedDriverToRated = (driver) => {
        const driversVM = _.get(submissionVM, `${driversVMPath}`);
        const foundDriver = driversVM.findFirstElement(driver);
        foundDriver.type_ML.value = getRatedDriverType();
        foundDriver.status_ML.value = getInsureDriver();
        resetPlaceholderObjs();
    };

    const undoDriverRemoval = (driver) => {
        // paModel.undoRemovedDriverEntry();
        driverList.push(driver);
        setRemovedDriverToRated(driver);
    };

    const getDriverVM = (driver) => {
        const driversVM = _.get(submissionVM, `${driversVMPath}`);
        return driversVM.findFirstElement(driver);
    };

    const removeDriver = (driver, index) => {
        addRemovedDriverToAvailableCandidates(submissionVM, driver);
        submissionVM.value.lobData.personalAuto.coverables.removeDriver(driver);
        disregardFieldValidation(`driver${index}`);
        refreshData();
    };

    const removeDriverWithHistoryEvent = (driver, index) => {
        updateRecentlyDeletedEntity(driver);
        removeDriver(driver, index);
        const msg = translator(removeDriverMessages.DriverHasBeenRemoved);
        addAlertMessage(getFullName(driver.person), msg, () => { undoDriverRemoval(driver) }, 'success', 'removedDriverNotHouse');
    };

    const removeDriverAddHouseholdMember = (driver) => {
          if(isModernProduct){
             driver.type_ML = getHouseholdNonDriverType(driver, isModernProduct, submissionVM.baseData?.canExcludeDrivers_ML?.value, submissionVM.baseData.policyAddress.state.value.code);
        } else {
            driver.type_ML = getHouseholdDriverType();
        }
        updateRecentlyDeletedEntity(driver);
        driver.editMode_ML = false;
        let msg = translator(removeDriverMessages.DriverHasBeenAddedAsAHouseHoldMember);
        if (isModernProduct) {
                    msg = translator(removeDriverMessages.DriverHasBeenAddedAsANonDriver);
                }
        addAlertMessage(getFullName(driver.person), msg, () => { setRemovedDriverToRated(driver) }, 'success', 'addedDriverHouseMember');
    };

    const removeDriverExclusion = (driverToExclude) => {
        driverToExclude.type_ML = getExcludedDriverType();
        updateRecentlyDeletedEntity(driverToExclude);
        driverToExclude.editMode_ML = false;
        const msg = translator(removeDriverMessages.DriverHasBeenExcluded);
        const help = {
            title: translator(removeDriverMessages.RemoveDriverExclusionHelpTitle),
            message: translator(removeDriverMessages.RemoveDriverExclusionHelpText)
        };
        addAlertMessage(getFullName(driverToExclude.person), msg, () => { setRemovedDriverToRated(driverToExclude) }, 'success', 'removedDriverExclusion', help);
    };

    const driverRemovalRules = (driverToRemove, index) => {
        clearBlockAlerts('invalidRemovalReason');
        clearBlockAlerts('cannotRemoveMarriedDriver');
        if (_.isUndefined(driverToRemove.status_ML)) {
            driverToRemove.status_ML = "insure_driver";
        }
        if (
            isModernProduct &&
            directRemoveStatuses.includes(driverToRemove.status_ML)
        ) {
            removeDriver(driverToRemove, index);
        }
        if (driverToRemove?.maritalStatus_ML === "M" && isQnB) {
            const errorMessage = translator(messages.cannotRemoveMarriedDriver);
            addAlertMessage(undefined, errorMessage, undefined, 'error', 'cannotRemoveMarriedDriver');
        } else if (isDriverRemovalAddHouseholdMember(driverToRemove, isModernProduct,submissionVM.baseData?.canExcludeDrivers_ML?.value, submissionVM.baseData.policyAddress.state.value.code)) {
            removeDriverAddHouseholdMember(driverToRemove, index);
        } else if (isDriverRemovalExclusion(driverToRemove,isModernProduct)) {
            removeDriverExclusion(driverToRemove);
        } else if (driverToRemove?.maritalStatus_ML === "M" && isQnB) {
            const errorMessage = translator(messages.cannotRemoveMarriedDriver);
            addAlertMessage(undefined, errorMessage, undefined, 'error', 'cannotRemoveMarriedDriver');
        } else if (isDriverRemovalAddRatedDriver(driverToRemove)) {
            const errorMessage = translator(messages.notAValidReasonToRemoveThisDriver);
            addAlertMessage(undefined, errorMessage, undefined, 'error', 'invalidRemovalReason');
        } else {
            removeDriverWithHistoryEvent(driverToRemove, index);
        }
    };

    const removeDriverButtonClick = (evt, redirectedDriverVm) => {
        let driverVM;
        if (_.isUndefined(evt) && !_.isUndefined(redirectedDriverVm)) {
            driverVM = redirectedDriverVm;
        } else if (isHVQAddtlInfoPage) {
            const auxDriverList = _.filter(_.get(submissionVM, `${driversVMPath}.children`), (driver) => !driver.bridgedFromHVQ_ML.value);
            const driverObj = auxDriverList[evt.index].value;
            driverVM = submissionVM.lobData.personalAuto.coverables.drivers.findFirstElement(driverObj);
        } else {
            const orderedDriverObj = orderedRatedDriverList[evt.index].value;
            driverVM = submissionVM.lobData.personalAuto.coverables.drivers.findFirstElement(orderedDriverObj);
        }

        _.set(driverVM, 'isPreparedToRemove_ML.value', true);
        const driverName = _.get(driverVM, 'person.displayName.value').toUpperCase();
        const removeDriverModelTitle = isQnB && !isModernProduct ? `${translator(removeDriverMessages.remove)} ${driverName}` :`${translator(removeDriverMessages.remove)}`;
        const driversOnSubmission = submissionVM.lobData.personalAuto.coverables.drivers;
        const originalIsDobAvailable = driverVM.isDobAvailable_Ext?.value;

        // Force DOB required only if DOB was available
        if (
            driverVM.fromPrefill_ML?.value === true &&
            originalIsDobAvailable === true
        ) {
            _.set(driverVM, 'isDobAvailable_Ext.value', false);
        }

        const validateUniqueDriverRelationship_Ext = (code, message) => {
            if (driverVM.relationshipToInsured_ML.value && driverVM.relationshipToInsured_ML.value.code === code) {
                for (let i = 0; i < driversOnSubmission.length; i++) {
                    const driver = driversOnSubmission.value[i];
                    if (driver !== driverVM && driver.relationshipToInsured_ML && driver.relationshipToInsured_ML === code) {
                        return message;
                    }
                }
            }
        };

        const isValidHouseholdSpouse = (driverToRemove) => {
            return driverToRemove.relationshipToInsured_ML === 'spouse' && ['never_licensed', 'abroad'].includes(driverToRemove.status_ML);
        };

        const onRemoveDriverValidation = ({ value: driverToRemove }) => {
            const validationResult = validateDriverRemoval(driverToRemove, submissionVM.value);
            // If we already have validation errors, we shouldnt run this to avoid overwriting the values.
            if (!validationResult.hasError && !isValidHouseholdSpouse(driverToRemove) && (!isStateND(policyStateCode) && !isStateMD(policyStateCode))) {
                validationResult.errorMessage = validateUniqueDriverRelationship_Ext(SELF_TAG, translator(messages.selfSelected_Ext))
                    || validateUniqueDriverRelationship_Ext(SPOUSE_TAG, translator(messages.spouseSelected_Ext));
            }
            if (validationResult.hasError || validationResult.errorMessage) {
                return validationResult.errorMessage;
            }
            return true;
        };

        const getRemoveDriverReasonLabel = () => {
                    return translator(removeDriverMessages.gpaReason, {
                        name: driverName
                    });
                };

        const onRemoveDriver = ({ value: driverToRemove },) => {
            const driverIndex = getSelectedDriverIndex(driverToRemove)
            driverRemovalRules(driverToRemove, driverIndex);
             if (driverToRemove.dateOfBirth?.value) {
            _.set(driverToRemove, 'isDobAvailable_Ext.value', true);
        }
            updateWizardData(submissionVM);
            MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Remove Driver`);
            return true;
        };

        const onCancelRemoveDriver = () => {
            _.set(driverVM, 'isPreparedToRemove_ML.value', false);
            _.set(driverVM, 'isDobAvailable_Ext.value', originalIsDobAvailable);
        };

        const nbGenderStatePopup = _.get(submissionVM, 'baseData.isValidNonBinaryGenderState_Ext.value');

        let genderVisible = false;
        const genderValue = driverVM.gender.value == null;

        if(genderValue){
            genderVisible = true;
        }

        
        const componentProps = {
            title: removeDriverModelTitle,
            uiProps: removeDriverMetadata.pageContent,
            viewModel: driverVM,
            actionBtnLabel: removeDriverMessages.yesRemove,
            cancelBtnLabel: removeDriverMessages.dontRemove,
            modalBodyStyles: removeDriverModalBodyStyles,
            onSaveAction: onRemoveDriverValidation,
            showBannerMessage: true,
            discardChangesOnCancel: true,
            viewModelService,
            getOverrideProps: () => {
                return {
                    reason: {
                        label: isQnB && isModernProduct ? getRemoveDriverReasonLabel() : translator(removeDriverMessages.reason),
                        availableValues: isQnB && !isModernProduct ? getRemoveDriverOptions() : isModernProduct ? getModernProductRemoveDriverOptions() : getRemoveDriverExcludedOptions()

                    },
                    // We're validating now using 'onRemoveDriverValidation' return value,
                    // using the built-in 'showBannerMessage' functionality in FormModalPopover.
                    errorNotification: {
                        visible: false
                    },
                     driverGender: {
                        path: 'gender',
                        visible: genderVisible,
                        availableValues: getFilteredGender(nbGenderStatePopup)
                    },
                    dobRow: {
                        visible: isQnB && isModernProduct 
                        ? driverVM?.fromPrefill_ML?.value
                        : isQnB && qnBDobFieldVisibility(driverVM.value)
                    }
                };
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(onRemoveDriver, onCancelRemoveDriver);
    };

    const addNewRatedDriverModel = () => {
        const driverObj = {
            accidents: '0',
            violations: '0',
            tempID: EntityUtil.nextId()
        };
        driverObj.person = {
            tempID: EntityUtil.nextId(),
            primaryAddress: submissionVM.baseData.policyAddress.value,
            middleName: null
        };
        driverObj.licenseState = driverObj.person.primaryAddress.state;

        // set partialDriverAdditionFlag_ML to "true" to avoid requiredness for other fields
        driverObj.partialDriverAdditionFlag_ML = true;
        driverObj.type_ML = getRatedDriverType();
        driverObj.error = {
            message: null
        };
        driverObj.editMode_ML = true;

        const { _xCenter, _dtoName } = submissionVM.lobData.personalAuto.coverables.drivers;
        const driverVM = viewModelService.create(driverObj, _xCenter, _dtoName);

        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add Driver`);

        return driverVM;
    };

    const renderAddEditDriverModal_Ext = (driverVM, isEdit, saveAction, cancelAction = _.noop) => {
         let insuredCandidateSelectedML = false;
        const setInsuredCandidateSelectedML = (bool) => {
            insuredCandidateSelectedML = bool;
        };

        const insuredCandidatesProps = isEdit ? { visible: false } : {
            submissionVM,
            driverVM,
            driverType: getRatedDriverType(),
            setInsuredCandidateSelected: setInsuredCandidateSelectedML,
            viewModelService
        };
         const nbGenderState = _.get(submissionVM, 'baseData.isValidNonBinaryGenderState_Ext.value');
         const driverHeading = isEdit ? messages.editDriver : messages.addNewDriver;
         const pniDriverId = _.get(submissionVM, 'baseData.accountHolder.publicID.value');
         const currentDriverId = _.get(driverVM, 'person.publicID.value');
         const isPNISelfDriver = _.isString(pniDriverId) && _.isString(currentDriverId) && pniDriverId === currentDriverId;

        const componentProps = {
            title: driverHeading,
            uiProps: addDriverMetadata.pageContent,
            viewModel: driverVM,
            actionBtnLabel: isEdit ? commonMessages.mlSave : commonMessages.mlContinue,
            cancelBtnLabel: isEdit ? editDriverMessages.cancelLabel_Ext : undefined,
            modalBodyStyles: addDriverModalBodyStyles,
            discardChangesOnCancel: isEdit,
            viewModelService,
            getOverrideProps: () => {
                return {
                    insuredCandidatesComponent: insuredCandidatesProps,
                    formFieldsContainer: {
                        visible: (insuredCandidateSelectedML && !isEdit) || isEdit
                    },
                   nameDetailsComponent: {
                               personVM: driverVM.person,
                               isComponent: true,
                               submissionVM,
                           },
                           relationship: {
                               disabled: isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI(driverVM) || isPNISelfDriver
                           },
                           dob: {
                               disabled: isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI(driverVM),
                           },
                           dobPopupControl: {
                               className: isQnB ? "col-md-12 remove-form-group-spacing" : "col-md-4 remove-form-group-spacing"
                           },
                           dobRow: {
                               className: isQnB ? "row help-text-row vertical-spacing-40 col-md-12 qnbFieldForToolTip" : "row help-text-row vertical-spacing-40 col-md-12"
                           },
                           statePopupControl: {
                               className: isQnB ? "col-md-12 remove-form-group-spacing" : "col-md-4 remove-form-group-spacing"
                           },
                           dobTooltipContainer: {
                               className: isQnB ? "col-md-6-qb tooltipContainerOverride" : "col-md-6 tooltipContainerOverride"
                           },
                           stateTooltipContainer: {
                               className: isQnB ? "col-md-6-qb tooltipContainerOverride" : "col-md-6 tooltipContainerOverride"
                           },
                           checkUniqueSelf: {
                               visible: driverList && !checkUniqueSelf(isEdit ? driverList : [driverVM.value, ...driverList])
                           },
                           checkUniqueSpouse: {
                               visible: driverList && !checkUniqueSpouse(isEdit ? driverList : [driverVM.value, ...driverList])
                           },
                           genderRow: {
                               availableValues: getFilteredGender(nbGenderState),
                               disabled: isQnB && (submissionVM.value.isQuoted() || isQuoted(submissionVM?.quoteID?.value) || !_.isEmpty(_.get(submissionVM, 'quoteData.paymentQuotes_ML.value'))) && checkIsDriverPNI(driverVM),
                               className: isQnB ? "radioButtonQnB row col-md-4 vertical-spacing-10" : "row col-md-4 vertical-spacing-10"
                           },
                           saveButton: {
                               className: isQnB ? "save-button-style" : ""
                           },
                           buttonsCol: {
                               className: isQnB ? "col-md-12 button-col" : "col-md-12"
                           }
                };
            },
            customComponentResolvers: {
                mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
                mlnamedetailscomponent: MLNameDetailsComponent,
            },
            onSaveAction: saveAction,
            onCancelAction: cancelAction
        }

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const addDriverButtonClick_Ext = () => {
        filterAvailableAutoInsuredCandidates(submissionVM, driverList);
        const driverVM = addNewRatedDriverModel();

        const onAddDriver = (driverToAddVm) => {
            const validationResult = validateDriverAddition(driverToAddVm.value, driverList);
            if (validationResult.hasError) {
                return false;
            }
            populateDriverPerson(driverToAddVm.value);
            const msg = translator(messages.hasBeenAdded);
            addAlertMessage(getFullName(driverToAddVm.value.person), msg, undefined, 'success', 'addedDriver');
            MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Add Driver`);

            updateRecentlyAddedDriver(driverToAddVm);
            submissionVM.lobData.personalAuto.coverables.drivers.pushElement(driverToAddVm);
            refreshData();

            return true;
        };

        renderAddEditDriverModal_Ext(driverVM, false, onAddDriver);
    };

    const editDriverButtonClick_Ext = (evt) => {
        const orderedDriverObj = orderedRatedDriverList[evt.index];
        const driverVM = submissionVM.lobData.personalAuto.coverables.drivers.findFirstElement(orderedDriverObj);
        driverVM.editMode_ML.value = true;
        driverVM.isPolicyHolderOrPrefilledFlag_Ext.value = false;
         const originalIsDobAvailable = driverVM.isDobAvailable_Ext?.value;

        // Force DOB required only if DOB was available
        if (
            driverVM.fromPrefill_ML?.value === true &&
            originalIsDobAvailable === true
        ) {
            _.set(driverVM, 'isDobAvailable_Ext.value', false);
        }

        const onEditDriver = () => {
            if (!checkUniqueSelf(driverList)) {
                return false;
            }
            if (driverVM.dateOfBirth?.value) {
            _.set(driverVM, 'isDobAvailable_Ext.value', true);
        }
            refreshData();

            const msg = translator(messages.hasBeenEdited);

            addAlertMessage(driverVM.person.displayName.value, msg, undefined, 'success', 'edited Driver');

            return true;
        };

         const onCancelEditDriver = () => {
            // Restore original value
            _.set(driverVM, 'isDobAvailable_Ext.value', originalIsDobAvailable);
            refreshNamedOrPrefillStatus_Ext();
        };

        renderAddEditDriverModal_Ext(driverVM, true, onEditDriver, onCancelEditDriver);
    };

    /**
     * Vehicle Actions
     */

    const getYearMakeModelNameML = (vehicleVM) => {
        const vehicle = vehicleVM.value || vehicleVM;
        let name = vehicle.year || '';
        if (vehicle.make) {
            if (name) {
                name += ' ';
            }
            name += vehicle.make;
        }
        if (vehicle.model) {
            if (name) {
                name += ' ';
            }
            name += vehicle.model;
        }

        if (name.length < 1) {
            name = translator({ id: 'fnol.common.model.Unnamed', defaultMessage: 'Unnamed' });
        }

        return name;
    };

    const addVehicleModel = () => {
        const primaryNamedInsured = submissionVM.baseData.primaryNamedInsured_ML.value;
        const vehicleObj = {
            tempID: submissionVM.value.nextId(),
            licenseState: primaryNamedInsured.primaryAddress.state
        };
        const { _xCenter, _dtoName } = submissionVM.lobData.personalAuto.coverables.vehicles;
        const vehicleVM = viewModelService.create(vehicleObj, _xCenter, _dtoName);
        vehicleVM.error = {
            message: null
        };
        vehicleVM.editMode_ML = true;
        updateRecentlyAddedVehicle(vehicleVM);
        return vehicleVM;
    };

    const removeVehicleButtonClick = (evt) => {
        const { index } = evt;
        vehicleToBeRemovedFlags[index] = true;
        setVehicleToBeRemovedFlags([...vehicleToBeRemovedFlags]);
    };

    const dontRemoveVehicleButtonClick = (evt) => {
        const { index } = evt;
        vehicleToBeRemovedFlags[index] = false;
        setVehicleToBeRemovedFlags([...vehicleToBeRemovedFlags]);
    };

    const yesRemoveVehicleButtonClick = (evt) => {
        const { index } = evt;
        const vehiclesListPath = 'lobData.personalAuto.coverables.vehicles.value';
        const vehiclesList = _.get(submissionVM, vehiclesListPath);
        const vehicleToBeRemoved = vehicleList[index];
        const undoVehicleRemoval = () => {
            const currentVehiclesList = _.get(submissionVM, vehiclesListPath);
            currentVehiclesList.push(vehicleToBeRemoved);
            resetPlaceholderObjs();
            updateInvalidPrefillBanner_Ext();
        };
        const msg = translator(messages.hasBeenRemoved);
        addAlertMessage(getYearMakeModelNameML(vehicleToBeRemoved), msg, undoVehicleRemoval, 'success', 'removedVehicle');
        vehiclesList.splice(index, 1);
        _.set(submissionVM, vehiclesList, vehiclesListPath);
        setVehicleToBeRemovedFlags(vehiclesList.map(() => false));
        disregardFieldValidation(`vehicle${index}`);
        refreshData();
        updateInvalidPrefillBanner_Ext();
    };

    const removeVinIfNotNeeded = (vehicle) => {
        const categoriesWithoutVin = ['low_speed_vehicle', 'registered_golf_cart', 'trailer'];
        if (categoriesWithoutVin.includes(vehicle.category_ML)) {
            vehicle.vin = undefined;
        }
    };

    const renderAddEditVehicleModal_Ext = (vehicleVM, isEdit, saveAction) => {
        const vehicleHeading = isEdit ? messages.prefillEditVehicleHeading : messages.prefillNewVehicleHeading;
        const newVehicleSubTitle = messages.prefillNewVehicleSubTitle;
        const editVehicleSubTitle = messages.prefillEditVehicleSubTitle;
        newVehicleSubTitle.args = {
            br: <br />
        };

        const componentProps = {
            title: vehicleHeading,
            subtitle: isEdit ? editVehicleSubTitle : newVehicleSubTitle,
            CustomComponent: MLPartialVehicleDetailsComponent,
            viewModel: vehicleVM,
            showFooterOnCustomComponent: true,
            actionBtnLabel: translator(isEdit ? commonMessages.mlSave : commonMessages.mlContinue),
            cancelBtnLabel: isEdit ? translator(commonMessages.mlCancel) : null,
            onSaveAction: saveAction,
            showBannerMessage: true,
            discardChangesOnCancel: isEdit,
            overrideProps: {
                submissionVM: submissionVM,
                showProgressDialog,
                hideProgressDialog,
                updateVinErrorCheck,
                vinErrorCheck,
            },
            viewModelService
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        );
    };

    const addVehicleButtonClick = () => {
        
        const removeNonOwnedVehicles = () => {
            const namedNonOwnerVehs = paModel.vehicles.filter((veh) => veh.namedNonOwner_ML === true);
            if (namedNonOwnerVehs.length > 0) {
                namedNonOwnerVehs.forEach((nonOwnerVeh) => {
                    paModel.removeVehicle(nonOwnerVeh);
                });
            }
        };

        removeNonOwnedVehicles();
        const vehicleVM = addVehicleModel();

        vehicleVM.isSerialNumberRequired_ML = false;
        vehicleVM.isCompRaterQuote = !!submissionVM.hvqQuoteID_ML.value;

        const onSaveVehicle = () => {
            const policyEffDate = submissionVM.baseData.periodStartDate.value;
            const validationResult = validateVehicleAddition(vehicleVM.value, vehicleList, policyEffDate);
            if (validationResult.hasError) {
                return validationResult.errorMessage;
            }
            const msg = translator(messages.hasBeenAdded);
            addAlertMessage(getYearMakeModelNameML(vehicleVM), msg, undefined, 'success', 'addedVehicle');
            readyVehicleForSave(vehicleVM);
            vehicleVM.editMode_ML = false;
            vehicleVM.isCostNewRequired_ML = false;
            vehicleVM.financeCategory_ML = 'owned';
            vehicleVM.parkedAtPrimary_ML = true;
            removeVinIfNotNeeded(vehicleVM);
            submissionVM.lobData.personalAuto.coverables.vehicles.pushElement(vehicleVM);
            updateWizardData(submissionVM);
            setVehicleToBeRemovedFlags([...vehicleToBeRemovedFlags, false]);
            refreshData();
            return true;
        };

        renderAddEditVehicleModal_Ext(vehicleVM, false, onSaveVehicle);
    };

    const editVehicleButtonClick_Ext = (evt) => {
        const vehicle = vehicleList[evt.index];
        const vehicleVM = submissionVM.lobData.personalAuto.coverables.vehicles.findFirstElement(vehicle);
        vehicleVM.editMode_ML.value = true;
        vehicleVM.partialVehicleAdditionFlag_Ext.value = true;

        const onEditVehicle = () => {
            vehicleVM.editMode_ML.value = false;
            vehicleVM.partialVehicleAdditionFlag_Ext.value = false;

            const policyEffDate = submissionVM.baseData.periodStartDate.value;
            const validationResult = validateVehicleAddition(vehicle, vehicleList, policyEffDate);
            if (validationResult.hasError) {
                return validationResult.errorMessage;
            }
            updateRecentlyAddedVehicle(vehicleVM);
            updateWizardData(submissionVM);
            return true;
        };  
        updateWizardData(submissionVM); 
        renderAddEditVehicleModal_Ext(vehicleVM, true, onEditVehicle);
    };

    const hasOnlyTrailers = () => {
        const vehicles = _.get(submissionVM, vehiclesPath);
        return vehicles.length > 0 && !vehicles.find((veh) => !isTrailer(veh));
    };

    const goToContactUs = () => {
        const errorParams = createOnlyTrailerError(submissionVM.quoteID.value);
        // Running Promise.reject will throw us out of wizard and to contact us, passing in error state
        Promise.reject((errorParams));
    };

    const areVehiclesValid = () => {
        let valid = true;
        const vehicleVM = _.get(submissionVM, vehiclesVMPath, []);
        const isVehicleTypeMissing = vehicleVM?.value.length > 0 && !vehicleVM?.value?.[0]?.type_ML && vehicleVM?.value?.[0]?.displayName !== "null null null"
        const vehicleInvalid = !vehicleVM.aspects.valid || !vehicleVM.aspects.subtreeValid || isVehicleTypeMissing ;
        if(vehicleInvalid){
            valid = false
        }
        if (hasOnlyTrailers()) {
            valid = false;
            goToContactUs();
        }

        return valid;
    };

    const isValid = () => {
        return areVehiclesValid();
    };

    // Redirect Functions
    const handleStepAction = (redirectAction) => {
        if (!_.isEmpty(redirectAction)) {
            if (redirectAction.action === ACTION_ADD_DRIVER) {
                addDriverButtonClick_Ext();
            } else if (redirectAction.action === ACTION_REMOVE_DRIVER) {
                const driverVM = getDriverVM(redirectAction.model);
                // Pass undefined for event and directly pass in driver VM
                removeDriverButtonClick(undefined, driverVM);
            } else if (redirectAction.action === ACTION_ADD_VEHICLE) {
                addVehicleButtonClick();
            }
        }
    };

    useEffect(() => {
        initDrivers();

        const stepDataML = _.get(submissionVM, 'value.wizardActionDataML', {});
        if (!_.isEmpty(stepDataML)) {
            handleStepAction(stepDataML);
            _.set(submissionVM, 'value.wizardActionDataML', {});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getQuoteID = () => {
        return submissionVM.quoteID.value;
    };

     const orderReportsForPrefillVehicles = async (res) => {
            if (isModernProduct) {
                try {
                    const jobNumber = getQuoteID();
                    if (jobNumber) {
                        await MLVehicleInfoLookupService.orderReportsForPrefillVehicles(
                            jobNumber
                        );
                    }
                    const requestData = {
                        quoteID: submissionVM.quoteID.value,
                        postalCode: submissionVM.baseData?.policyAddress?.postalCode?.value?.substring(0, 5)
                    };
                    const submissionLoadPromise = LoadSaveService.retrieveSubmission(requestData);
                    try {
                        const sub = await submissionLoadPromise;
                        const subVM = viewModelService.create(sub, 'pc', 'edge.capabilities.quote.submission.dto.QuoteDataDTO');
                        _.set(res, 'lobData.personalAuto.coverables.vehicles', _.get(subVM, 'value.lobData.personalAuto.coverables.vehicles'));
                        // only backfill persons when res is missing it; never overwrite persons res already has
                        if (_.isEmpty(_.get(res, 'persons')) && !_.isEmpty(_.get(subVM, 'value.persons'))) {
                            _.set(res, 'persons', _.get(subVM, 'value.persons'));
                        }
                        return res
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.error(error);
                    }
                } catch (e) {
                    // non-blocking failure
                    console.warn('Failed to generate Prefill order report', e);
                }
            }
        }
    // End Redirect Functions

    const onNext = async () => {
        const validationErrors = [];

        const vehicles = _.get(submissionVM, vehiclesPath);

        if (vehicleList.length === 0) {
          clearBlockAlerts("noVehicleSelected");
          addErrorAlert(messages.noVehicleSelected, "noVehicleSelected");
          return false;
        } 
        
         if (vehicles?.length > 0 && isModernProduct) {
            const hasTrailerNP = vehicles.some(vehicle => isTrailerNP(vehicle) && !vehicle.removed);
            const hasCamper = vehicles.some(vehicle => isCamperNP(vehicle) && !vehicle.removed);
            const hasOther = vehicles.some(vehicle => !isTrailerNP(vehicle) && !isCamperNP(vehicle) && !vehicle.removed);
            clearBlockAlerts('invalidVhicleAdd');
            if (!hasOther && (hasCamper || hasTrailerNP)) {
                const errorMessage = translator(messages.aTrailerOrCamperCannotBeTheOnlyVehicleOnThePolicy);

                addAlertMessage(undefined, errorMessage, undefined, 'error', 'invalidVhicleAdd');
                return false;
            }
        }
        if (isQnB && orderedRatedDriverList.length > DRIVERS_LIMIT) {
            validationErrors.push({
                key: 'exceedDriverLimit',
                message: messages.exceedDriverLimit
            });
        }

        if (isQnB && vehicleList.length > VEHICLES_LIMIT) {
            validationErrors.push({
                key: 'exceedVehicleLimit',
                message: messages.exceedVehicleLimit
            });
        }

        if (validationErrors.length > 0) {
            clearWarningAlerts();

            validationErrors.forEach(({ key, message }) => {
                addWarningAlert(translator(message), key);
            });

            window.scrollTo({ top: 0, behavior: 'smooth' });
            return false;
        }
         // DOB validation for prefilled QB drivers
        const invalidDobDriver = orderedRatedDriverList.some((driverVM) =>
            driverVM.value.fromPrefill_ML === true
            && driverVM.value.isDobAvailable_Ext === false
            && !driverVM.value.dateOfBirth
        );

        if (invalidDobDriver) {
            return false;
        }

        const createNamedNonOwner = () => {
            const primaryNamedInsured = submissionVM.value.getPrimaryNamedInsured();
            if (!paModel.hasNamedNonOwner()) {
                const namedNonOwnerVehicle = paModel.createVehicle(primaryNamedInsured);
                namedNonOwnerVehicle.namedNonOwner_ML = true;
                namedNonOwnerVehicle.costNew = {
                    amount: 0
                };
                namedNonOwnerVehicle.additionalInterests_ML = [];
            }
        };

        if (!isValid()) {
            setErrorTimestamp(errorTimestamp + 1);
            return false;
        }
        if (paModel.vehicles.length === 0) {
            createNamedNonOwner();
        }
        _.unset(submissionVM.value, 'bindData');
        _.set(submissionVM, 'portalCurrentStep_ML.value', 'paPreFillData');

        PATrackEvent('Quote Step Submitted', false, submissionVM, null, { step: 'Prefill Results', action: 'Prefill Results Submitted' }, true);

        if (isModelValid()) {
            let response;
             driverList.forEach((driver) => {
                if (
                    driver.fromPrefill_ML === true &&
                    driver.dateOfBirth != null
                ) {
                    driver.fromPrefill_ML = false;
                }
            });
            showProgressDialog(commonMessages.saveSubmission);
            try {
                response = await LoadSaveService.updateDraftSubmission(submissionVM.value);
                
                let orderReportResult = await orderReportsForPrefillVehicles(response);

                    if(orderReportResult !== undefined){
                        submissionVM.value = orderReportResult
                    }
                    else{
                    submissionVM.value = response;
                    }
            } finally {
                const nextStepName = isHVQAddtlInfoPage ? 'paHVQConsumerDriverDetails' : 'paDriverDetails';
                MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName);
                hideProgressDialog();
            }
            if (!nextStepVisited()) {
                return submissionVM;
            }
            updateWizardSnapshot(submissionVM);
            goNext();
        }
        return false;
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onAddDriverButtonClicked: addDriverButtonClick_Ext,
            onRemoveDriverButtonClicked: removeDriverButtonClick,
            onEditDriverButtonClicked: editDriverButtonClick_Ext,
            onRemoveVehicleButtonClicked: removeVehicleButtonClick,
            onEditVehicleButtonClicked: editVehicleButtonClick_Ext,
            onYesRemoveVehicleButtonClicked: yesRemoveVehicleButtonClick,
            onDontRemoveVehicleButtonClicked: dontRemoveVehicleButtonClick,
            onAddVehicleButtonClick: addVehicleButtonClick,
            onValidate,
            onNext
        }
    };

    const skipOnResumeIf = () => {
        if (!!_.get(submissionVM, 'bindData.policyNumber.value')
            && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
            return true;
        }

        if (currentStep.mlStepName === 'paHVQConsumerAdditionalDrivers' && !(submissionVM.hvqQuoteID_ML && submissionVM.hvqQuoteID_ML.value)) {
            return true;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'paPreFillData') {
            return false;
        }

        if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
            submissionVM.hvqQuoteID_ML.value &&
            submissionVM.isBundle_ML.value) {
            return true;
        }

        if (submissionVM.value.isBundle_ML
            && submissionVM.value.baseData.status_ML !== 'Draft') {
            return true;
        }

        return true;
    };

    return (
        <WizardPage
            skipWhen={skipOnResumeIf}
            showCancel={false}
            showPrevious={false}
            showNext={!nextStepVisited()}
            onNext={onNext}
            nextLabel={translator(commonMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited()}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && _.get(metadata, 'pageContent.id')}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                overrideProps={overrideProps}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                onModelChange={updateWizardData}
                // onValueChange={writeValue}
                classNameMap={resolvers.resolveClassNameMap}
                onValidationChange={onValidate}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

PrefillPage.propTypes = wizardProps;
export default PrefillPage;